//import Container from "@mui/material/Container";
//import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
//import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import { useQuery, useMutation } from "@apollo/client";
import { FIND_PROPOSALS_BY_SECTION, CREATE_VOTING, FIND_VOTES_BY_SECTION } from "queries";
import { Button, Card, CardContent } from "@mui/material";
//import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
// Material Kit 2 React examples
//import DefaultFooter from "examples/Footers/DefaultFooter";
//import Card from "@mui/material/Card";
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/proposals/DesignBlocks";
//import Pages from "pages/Presentation/proposals/Pages";
//import Testimonials from "pages/Presentation/proposals/Testimonials";
//import Download from "pages/Presentation/proposals/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";
import React, { useState, useEffect } from "react";
// Routes
//import routes from "routes";
//import footerRoutes from "footer.routes";
// Images
//import bgImage from "assets/images/strategia.jpg";
//import { ALL_MUNICIPALITIES } from "queries";

/* eslint-disable react/prop-types */
// eslint-disable-next-line
const Proposals = ({ selectedKunta, setSelectedKunta, originalProposal, setError }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //console.log(selectedKunta);
  //console.log(setSelectedKunta);
  const [proposals, setProposals] = useState([]);
  //const [idea, setIdea] = useState("");
  //const [selected, setSelected] = useState("Kommentit");
  const [votes, setVotes] = useState([]);
  //console.log(votes);
  //const [ideatext, setIdeatext] = useState("");
  //const [selected, setSelected] = useState([]);
  let section = useParams().id;
  const proposalssw = useQuery(FIND_PROPOSALS_BY_SECTION, {
    pollInterval: 100000,
    variables: { section },
  });
  const votessw = useQuery(FIND_VOTES_BY_SECTION, {
    pollInterval: 100000,
    variables: { section },
  });
  const [createVoting] = useMutation(CREATE_VOTING, {
    refetchQueries: [{ query: FIND_VOTES_BY_SECTION, variables: { section: section } }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  /*useEffect(() => {
    let valittu = proposals.filter(function (el) {
      return el.agendaid === meeting;
    });
    //console.log(valittu);
    setSelected(valittu);
  }, [selectedKunta, proposals]);*/
  useEffect(() => {
    let proposalss = [];
    //console.log(proposalssw);
    //let municipalitiess = [];
    if (proposalssw.data) {
      proposalss = proposalssw.data.findProposalsBySection;
      //setOrgans(organss);
      //console.log(proposalss);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setProposals(proposalss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [proposalssw]);
  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesBySection;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  const handleVote = (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    if (event === 0) {
      createVoting({
        variables: {
          userid: localStorage.getItem("id"),
          votedatetime: pvm.toString(),
          municipality: selectedKunta,
          sectionid: section,
        },
      });
    } else {
      createVoting({
        variables: {
          proposalid: event,
          userid: localStorage.getItem("id"),
          votedatetime: pvm.toString(),
          municipality: selectedKunta,
          sectionid: section,
        },
      });
    }
  };
  function voteCount(p) {
    //console.log(p);
    if (p === 0) {
      return votes.filter((a) => a.proposalid === null).length;
    } else {
      return votes.filter((a) => a.proposalid === p).length;
    }
  }
  return (
    <>
      <MKTypography
        variant="h1"
        color="black"
        mt={-6}
        mb={1}
        sx={({ breakpoints, typography: { size } }) => ({
          [breakpoints.down("md")]: {
            fontSize: size["3xl"],
          },
        })}
      >
        Päätösehdotukset
      </MKTypography>
      <b>Alkuperäinen</b>:
      <Card key="0" style={{ marginBottom: "0.5rem" }}>
        <CardContent
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <MKTypography>{originalProposal}</MKTypography>
          <Button variant="contained" style={{ color: "white" }} onClick={() => handleVote(0)}>
            👍 {voteCount(0)}
          </Button>
        </CardContent>
      </Card>
      <br />
      <br />
      <b>Vaihtoehtoiset</b>:
      <br />
      {proposals.map((p, index) => (
        <Card key={index} style={{ marginBottom: "0.5rem" }}>
          <CardContent
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MKTypography>{p.proposaltext}</MKTypography>
            <Button variant="contained" style={{ color: "white" }} onClick={() => handleVote(p.id)}>
              👍 {voteCount(p.id)}
            </Button>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default Proposals;
